declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}

const id = () => import.meta.env.VITE_META_PIXEL_ID as string | undefined;

const ready = () => typeof window.fbq === 'function' && !!id();

export const pixelPageView = () => {
  if (!ready()) return;
  window.fbq('track', 'PageView');
};

export const pixelViewContent = (params: {
  content_ids: string[];
  content_name: string;
  content_type?: string;
  value?: number;
  currency?: string;
}) => {
  if (!ready()) return;
  window.fbq('track', 'ViewContent', {
    content_ids: params.content_ids,
    content_name: params.content_name,
    content_type: params.content_type ?? 'product',
    value: params.value,
    currency: params.currency ?? 'USD',
  });
};

export const pixelAddToCart = (params: {
  content_ids: string[];
  content_name: string;
  value: number;
  currency?: string;
}) => {
  if (!ready()) return;
  window.fbq('track', 'AddToCart', {
    content_ids: params.content_ids,
    content_name: params.content_name,
    content_type: 'product',
    value: params.value,
    currency: params.currency ?? 'USD',
  });
};

export const pixelViewCart = (params: {
  value: number;
  num_items: number;
  currency?: string;
}) => {
  if (!ready()) return;
  window.fbq('trackCustom', 'ViewCart', {
    value: params.value,
    num_items: params.num_items,
    currency: params.currency ?? 'USD',
  });
};

export const pixelInitiateCheckout = (params: {
  value: number;
  num_items: number;
  currency?: string;
}) => {
  if (!ready()) return;
  window.fbq('track', 'InitiateCheckout', {
    value: params.value,
    num_items: params.num_items,
    currency: params.currency ?? 'USD',
  });
};

export const pixelPurchase = (params: {
  value: number;
  order_id: string;
  currency?: string;
}) => {
  if (!ready()) return;
  window.fbq('track', 'Purchase', {
    value: params.value,
    order_id: params.order_id,
    currency: params.currency ?? 'USD',
  });
};

export const pixelLead = () => {
  if (!ready()) return;
  window.fbq('track', 'Lead');
};

export const pixelCompleteRegistration = () => {
  if (!ready()) return;
  window.fbq('track', 'CompleteRegistration');
};
